/**
 * Korean translations
 */
import { TranslationKeys } from './en';

export const ko: TranslationKeys = {
  // Toolbar - Main buttons
  toolbar: {
    save: '저장',
    load: '불러오기',
    export: 'PDF 내보내기',
    select: '선택',
    rect: '사각형',
    circle: '원',
    arrow: '화살표',
    code: '코드',
    markdown: '마크다운',
    image: '이미지',
  },

  // Toolbar - Tooltips
  tooltips: {
    save: '저장하기',
    load: '불러오기',
    export: '내보내기 (Ctrl+Shift+E)',
    select: '올가미 선택 (V)',
    rect: '사각형 (R)',
    circle: '원 (C)',
    arrow: '화살표 (A)',
    code: '코드 블록',
    markdown: '마크다운',
    imageConcat: '이미지 연결',
  },

  // Toolbar - Properties
  properties: {
    startPoint: '시작점',
    endPoint: '끝점',
    curved: '곡선',
    color: '색',
    thickness: '두께',
    background: '배경',
    border: '테두리',
    font: '폰트',
    priority: '우선순위',
    items: '개',
  },

  // Minimap
  minimap: {
    zoom: '확대',
  },

  // Collaboration
  collaboration: {
    collab: '협업',
    title: '협업',
    createSession: '세션 생성',
    joinSession: '세션 참여',
    leaveSession: '세션 나가기',
    sessionId: '세션 ID',
    join: '참여',
    cancel: '취소',
    users: '참여자',
    you: '나',
    host: '호스트',
    exportUsers: '참여자 내보내기',
    back: '뒤로',
    create: '생성',
    leave: '나가기',
    copy: '복사',
    copied: '복사됨!',
    kick: '내보내기',
    participants: '참여자',
    yourName: '이름',
    enterName: '이름을 입력하세요',
    enterSessionId: '세션 ID 입력 (예: ABC12345)',
    startNewSession: '새 협업 세션을 시작하거나 기존 세션에 참여하세요.',
    startSession: '새 협업 세션 시작',
    joinWithId: '세션 ID로 참여',
    copySessionId: '세션 ID 복사',
    sessionInfo: '세션: {id} ({count}명) - 클릭하여 참여자 관리',
    peopleCount: '{count}명',
    kickConfirm: '{name}님을 내보내시겠습니까?',
    moreUsers: '{count}명 더',
    pleaseEnterName: '이름을 입력해주세요',
    pleaseEnterSessionId: '세션 ID를 입력해주세요',
  },

  // Modals
  modals: {
    // Export Modal
    export: {
      title: '내보내기',
      scope: '내보내기 범위',
      allObjects: '모든 객체',
      selectedOnly: '선택된 객체만',
      format: '형식',
      quality: '품질',
      exportBtn: '내보내기',
      exporting: '내보내는 중...',
      allCanvas: '전체 캔버스',
      includeAll: '모든 객체 포함',
      currentView: '현재 화면',
      visibleOnly: '보이는 영역만',
      selectedObjects: '선택된 객체',
      selectionOnly: '선택 영역만',
      selectObjects: '객체를 선택하세요',
      filename: '파일명',
      enterFilename: '파일명 입력',
      paperSize: '용지 크기',
      fitToContent: '콘텐츠에 맞춤',
      orientation: '방향',
      landscape: '가로',
      portrait: '세로',
      margin: '여백',
      resolution: '해상도',
      backgroundColor: '배경색',
      exportComplete: '내보내기 완료!',
      qualityLow: '낮음 (60%)',
      qualityMedium: '보통 (80%)',
      qualityHigh: '높음 (100%)',
      exportPdf: 'PDF 내보내기',
      exportJpg: 'JPG 내보내기',
    },
    // Image Concat Modal
    imageConcat: {
      title: '이미지 연결',
      dragDropText: '이미지를 드래그하거나 클릭하여 선택하세요',
      supportedFormats: 'PNG, JPG, GIF, WebP 지원 (여러 파일 선택 가능)',
      targetWidth: '목표 너비',
      auto: '자동 (가장 넓은 이미지에 맞춤)',
      trimMargins: '상하 여백 자동 제거',
      trimDescription: '(흰색/투명 영역)',
      noImages: '선택된 이미지 없음',
      confirm: '이미지 연결',
      cancel: '취소',
      close: '닫기 (ESC)',
      selectedImages: '선택된 이미지',
      clearAll: '전체 삭제',
      moveUp: '위로 이동',
      moveDown: '아래로 이동',
      delete: '삭제',
      resultWidth: '결과 이미지 너비',
      preview: '미리보기',
      processing: '처리 중...',
    },
    // Code Editor
    codeEditor: {
      title: '코드 편집기',
      language: '언어',
      save: '저장 (Ctrl+S)',
      cancel: '취소 (ESC)',
      placeholder: '코드를 입력하세요...',
      hint: 'Ctrl+Enter 저장, ESC 취소',
    },
    // Markdown Editor
    markdownEditor: {
      title: '마크다운 편집기',
      preview: '미리보기',
      save: '저장 (Ctrl+S)',
      cancel: '취소 (ESC)',
      edit: '편집',
      split: '분할',
      bold: '굵게 (Ctrl+B)',
      italic: '기울임 (Ctrl+I)',
      code: '코드',
      placeholder: '마크다운을 입력하세요...',
      previewHint: '*마크다운을 입력하면 미리보기가 표시됩니다.*',
      notionStyle: '노션 스타일 에디터',
      hint: '/ 슬래시 메뉴 • Ctrl+Enter 저장 • ESC 취소',
    },
  },

  // Context Menu
  contextMenu: {
    delete: '삭제',
    duplicate: '복제',
    bringToFront: '맨 앞으로',
    sendToBack: '맨 뒤로',
  },

  // Annotation Toolbar
  annotation: {
    highlighter: '형광펜 (H)',
    underline: '밑줄 (U)',
    eraser: '지우개 (E)',
    size: '크기:',
    opacity: '투명도:',
    solid: '실선',
    dashed: '점선',
    wavy: '물결',
    clearAll: '전체 지우기',
    close: '닫기 (Esc)',
    deleteConfirm: '모든 주석을 삭제하시겠습니까?',
  },

  // PDF Viewer
  pdf: {
    pageList: '페이지 목록 보기',
    extractPage: '이 페이지 추출하기',
    extract: '선택',
    outline: '목차',
    pages: '페이지',
    noOutline: '목차가 없습니다',
  },

  // Common
  common: {
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    delete: '삭제',
    close: '닫기',
    loading: '로딩 중...',
    error: '오류',
    success: '성공',
    back: '뒤로',
  },

  // Placeholder
  placeholder: {
    line1: 'PDF나 이미지 파일을 드래그 앤 드롭',
    line2: '자유롭게 도형을 만들어 설명을 붙이거나',
    line3: '클립보드의 이미지를 Ctrl+V로 붙여넣기',
  },

  // Help
  help: {
    title: '사용 가이드',
    sections: [
      { title: 'PDF / 이미지 추가', items: ['PDF나 이미지 파일을 캔버스에 드래그 앤 드롭', '클립보드의 이미지를 Ctrl+V로 붙여넣기'] },
      { title: '어노테이션 (형광펜/밑줄)', items: ['이미지 또는 PDF 객체를 더블클릭하여 어노테이션 모드 진입', '도구 선택 후 드래그하여 형광펜/밑줄 그리기', 'ESC 또는 외부 클릭으로 어노테이션 모드 종료', '단축키: H(형광펜), U(밑줄), E(지우개)'] },
      { title: '객체 조작', items: ['클릭으로 선택, 드래그로 이동', 'Ctrl+C / Ctrl+V: 복사 / 붙여넣기', 'Ctrl+D: 제자리 복제', 'Delete: 삭제', 'Ctrl+Z / Ctrl+Shift+Z: 실행 취소 / 다시 실행'] },
      { title: 'PDF 페이지', items: ['PDF 하단 ◀ ▶ 버튼으로 페이지 이동', '☰ 버튼으로 페이지 목록 보기', '"선택" 버튼으로 현재 페이지를 별도 객체로 추출'] },
      { title: '캔버스', items: ['마우스 휠로 확대/축소', '빈 공간 드래그로 캔버스 이동', 'YouTube URL 붙여넣기로 영상 추가'] },
    ],
  },

  // Settings
  settings: {
    language: '언어',
    english: 'English',
    korean: '한국어',
  },
};
